module.exports = __webpack_public_path__ + "home-main-graphic-with-bg@2x.32kC6DDn.png";